export const VARIANT_ID_QUERY_PARAM = 'variantId'
export const DEFAULT_TAKE = 36
